const FooterSection = ({children}) => {
    return ( 
        <section className="min-w-[170px] my-4 md:my-0">
            {children}
        </section>
    );
}

export default FooterSection;